import { render } from "./IconSwitch.vue?vue&type=template&id=9a91ca54"
import script from "./IconSwitch.vue?vue&type=script&lang=js"
export * from "./IconSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.0.11_vue@3.2.47_webpack@4.44.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__